import React, { Component } from 'react';
import { Row, Column } from '../../../Layouts';
import { Text } from '../../../UI/Text';
import { RightBoxContainer, TimeValue } from './style';
import { Timer } from '../../../Components/Timer';
import { getTimeUnits } from '../../../../Utils';
import { WorkoutOwnerAvatar } from '../LiveDisplay/Content/style';
import { config } from '../../../../Configurations';

export class TimerBox extends Component {
    state = {
        hours: '00',
        minutes: '00',
        seconds: '00',
    };

    getTimePassed = seconds => {
        this.setState(getTimeUnits(seconds));
    };

    render() {
        const {
            getTimePassed,
            props: {
                workoutInfo: { title },
                workoutOwner,
            },
            state: { hours, minutes, seconds },
        } = this;
        return (
            <RightBoxContainer>
                <Row align={'center'}>
                    <Timer passTime={getTimePassed} />
                    <Column align={'right'}>
                        <Text fontSize={18} weight={'bold'} uppercase={true}>
                            {title}
                        </Text>

                        <Row align={'center'}>
                            <TimeValue>
                                <Value>{hours}</Value>
                            </TimeValue>
                            <Separator />
                            <TimeValue>
                                <Value>{minutes}</Value>
                            </TimeValue>
                            <Separator />
                            <TimeValue>
                                <Value>{seconds}</Value>
                            </TimeValue>
                        </Row>
                    </Column>
                    <WorkoutOwnerAvatar background={`${config.baseUrl}${workoutOwner.smallImage}`} />
                </Row>
            </RightBoxContainer>
        );
    }
}

TimerBox.defaultProps = {
    workoutInfo: {},
    workoutOwner: {},
};

const Value = ({ children }) => (
    <Text fontSize={40} weight={'bold'}>
        {children}
    </Text>
);

const Separator = () => <Value>:</Value>;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Footer/TimerBox.js